export default __webpack_public_path__ + "static/media/awesome.619efe5b.gif";